import { AfterViewInit, Component, HostBinding, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface DividerBlock {
  dividerColor?: string;
  dividerHeight?: number;
}

// Default blank value
export const blankDividerBlock: DividerBlock = {
  dividerColor: null,
  dividerHeight: null,
};

@Component({
  selector: 'email-divider-block',
  templateUrl: './divider-block.component.html',
  styleUrls: ['./divider-block.component.scss'],
  standalone: false,
})
export class DividerBlockComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'email-divider-block';
  @Input() content: DividerBlock;
  @ViewChild('blockInputs') blockInputs: NgForm;

  private readonly subscriptions: Subscription[] = [];

  constructor(private emailPreview: EmailPreviewRefreshService) {}

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.blockInputs.form.valueChanges.subscribe(() => {
        this.emailPreview.refresh();
      }),
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
